import { createSelector } from 'reselect';

const selectViewsState = () => (state) => state.get('views');

export const selectEmailReports = () => createSelector(selectViewsState(), (substate) => substate.get('emailReports'));

export const selectLoading = () => createSelector(selectViewsState(), (substate) => substate.get('loading'));

export const selectErrors = () => createSelector(selectViewsState(), (substate) => substate.get('errors'));

export const selectNotifications = () =>
  createSelector(selectViewsState(), (substate) => substate.get('notifications'));

export const selectReportErrors = () => createSelector(selectViewsState(), (substate) => substate.get('reportErrors'));
